import { render } from "./YouTubeInsights.vue?vue&type=template&id=4a525c9a&scoped=true"
import script from "./YouTubeInsights.vue?vue&type=script&lang=js"
export * from "./YouTubeInsights.vue?vue&type=script&lang=js"

import "./YouTubeInsights.vue?vue&type=style&index=0&id=4a525c9a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a525c9a"]])

export default __exports__